import * as core from '../../../../../../../core'

import { query } from './engagement-charter-components-table.query'

export const RESOURCE = {
  payload: {
    alias: 'engagementCharterComponents.table',
    description:
      'Table view of engagement charter components, filtered by the app-level project (defaults to no project filter)',
    name: 'Engagement Charter Components Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
